import lang from './../../../languages/en'
import { regexAllCharacter, regexContainSpaces, atLeastOneUperCase, atLeastOneLowerCase, atLeastOneNumber } from './../../../services/ruleValidate';

export const checkValidatePassword = (newPassword, confirmNewPassword) => {
    let message = {}

    // merge password and confirm password
    if (newPassword.trim() !== confirmNewPassword.trim()) {
        message = {
            name: 'error',
            value: lang.password_not_match
        }
    }

    // least one uppercase
    if (!atLeastOneUperCase(confirmNewPassword)) {
        message = {
            name: 'confirmNewPassword',
            value: lang.least_on_uppercase_letter
        }
    }
    if (!atLeastOneUperCase(newPassword)) {
        message = {
            name: 'newPassword',
            value: lang.least_on_uppercase_letter
        }
    }

    // least on lower case
    if (!atLeastOneLowerCase(confirmNewPassword)) {
        message = {
            name: 'confirmNewPassword',
            value: lang.least_one_lowercase_letter
        }
    }
    if (!atLeastOneLowerCase(newPassword)) {
        message = {
            name: 'newPassword',
            value: lang.least_one_lowercase_letter
        }
    }

    // check lease on number
    if (!atLeastOneNumber(confirmNewPassword)) {
        message = {
            name: 'confirmNewPassword',
            value: lang.least_on_number
        }
    }
    if (!atLeastOneNumber(newPassword)) {
        message = {
            name: 'newPassword',
            value: lang.least_on_number
        }
    }

    // check character
    if (!regexAllCharacter(confirmNewPassword)) {
        message = {
            name: 'confirmNewPassword',
            value: lang.cannot_contain_double_byte
        }
    }
    if (!regexAllCharacter(newPassword)) {
        message = {
            name: 'newPassword',
            value: lang.cannot_contain_double_byte
        }
    }

    // check contain spaces
    if (!regexContainSpaces(confirmNewPassword)) {
        message = {
            name: 'confirmNewPassword',
            value: lang.cannot_contain_spaces
        }
    }
    if (!regexContainSpaces(newPassword)) {
        message = {
            name: 'newPassword',
            value: lang.cannot_contain_spaces
        }
    }

    // least eight character
    if (confirmNewPassword.length < 8) {
        message = {
            name: 'confirmNewPassword',
            value: lang.least_eight_character
        }
    }
    if (newPassword.length < 8) {
        message = {
            name: 'newPassword',
            value: lang.least_eight_character
        }
    }

    return message
}

export const checkInputEmpty = (value, name) => {
    let message = {}

    if (!value && name === 'oldPassword') {
        message = {
            name: name,
            value: lang.current_password,
        }
    }
    if (!value && name === 'confirmNewPassword') {
        message = {
            name: name,
            value: lang.new_password
        }
    }
    if (!value && name === 'newPassword') {
        message = {
            name: name,
            value: lang.confirm_new_password
        }
    }

    return message
}


// WEBPACK FOOTER //
// ./src/containers/auth/change-password/helper.js